import { useCurrentUser } from '@/hooks/dataHelpers';
import {
  DISPLAY_PREFS_STORAGE_KEY,
  selectSetFontFamily,
  useThemeStore,
  type FontFamilyPref,
} from '@/lib/store/themeStore';
import { fontFamilyPrefFromAccommodations } from '@/pages/experiences/utils/readingPrefsAccommodations';
import { useEffect } from 'react';

const hasStoredDisplayPrefs = (): boolean => {
  try {
    return window.localStorage.getItem(DISPLAY_PREFS_STORAGE_KEY) !== null;
  } catch {
    // Storage unavailable (private mode): treat as handled — seeding into a store that cannot remember it is worse.
    return true;
  }
};

/** Guard on KEY EXISTENCE, not value: `fontFamily: 'default'` means both "never chosen" and "deliberately off", so a value match would overrule the user. */
export const useSeedDisplayPrefsFromGrant = (): void => {
  const currentUser = useCurrentUser();
  const setFontFamily = useThemeStore(selectSetFontFamily);

  const grantedPref: FontFamilyPref | undefined = fontFamilyPrefFromAccommodations(
    currentUser?.custom_fields?.accommodations
  );

  useEffect(() => {
    // No identity gate needed: currentUser is whole-or-null, so a truthy grant already means login resolved.
    if (!grantedPref) return;
    if (hasStoredDisplayPrefs()) return;

    setFontFamily(grantedPref);
  }, [grantedPref, setFontFamily]);
};
